import Navbar from "../components/other/navbar";
import {Settings} from "../components/setting/other/Settings";
import Axios from "../Axios";
import {useState} from "react";

function Setting() {

    if(!sessionStorage.getItem('token')){
        window.location.href = '/login';
    }

    return (
        <div className="Home">
            <Navbar page={'Settings'}/>
            <div className="centered-element">
                <Settings/>
            </div>
        </div>
    );
}



export default Setting;